//
//
//
//
//
//

const default_layout = "default"

export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout"
    },
  },

  watch: {
    $route(to, from) {
      document.title = [to.meta.title, process.env.VUE_APP_TITLE].filter(Boolean).join(" | ")
    },
  },
}
